import React from 'react';

import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import { isMobile } from 'react-device-detect';

import ObjectiveSelector from './ObjectiveSelector';
import RenderOps from './RenderOps';
import { KdKanban } from '../../@types/State';
import { useIntelState } from '../../context/IntelState';
import RestUtilities from '../../services/RestUtilities';
import { initialState } from '../WarPlanner/helpers';
interface Props {
  isWarPlan: boolean;
}

const ProvinceOps: React.FC<Props> = ({ isWarPlan }) => {
  const { intelState, intelDispatch } = useIntelState();

  const savePlan = async () => {
    const state: KdKanban = intelState.enemyPlan ?? initialState;
    intelDispatch({
      type: 'SET_ENEMY_PLAN',
      payload: { ...state },
    });
    await RestUtilities.post(
      `WarPlan/v1/Post?server=${intelState.server}&location=${intelState.enemyKd}`,
      { json: JSON.stringify(state) }
    );
  };

  return (
    <Box
      sx={{
        paddingX: 1,
        paddingTop: 2,
      }}
    >
      {isWarPlan && (
        <Box
          sx={{
            mb: 1,
          }}
        >
          <ObjectiveSelector />
          <Divider sx={{ mt: 1 }} />
        </Box>
      )}
      <Typography variant='body1' textAlign='center'>
        Assign OPs
      </Typography>
      {isWarPlan && (
        <Typography variant='body2' textAlign='center' mt={2}>
          Remember to{' '}
          <Button
            variant='outlined'
            onClick={savePlan}
            size='small'
            color='warning'
          >
            Save Plan
          </Button>
        </Typography>
      )}
      <Grid
        container
        spacing={1}
        sx={{
          width: isMobile ? '100vw' : '250px',
          py: 2,
          textAlign: 'center',
        }}
      >
        <Grid size={6}>
          <Typography variant='body2' gutterBottom>
            {isWarPlan ? 'Duration Ops' : 'Requests'}
          </Typography>
          <Divider sx={{ margin: 1 }} />
          <RenderOps isDuration={true} isEnemy={isWarPlan} />
        </Grid>
        <Grid size={6}>
          <Typography variant='body2' gutterBottom>
            {isWarPlan ? 'Instant Ops' : 'Requests'}
          </Typography>
          <Divider sx={{ margin: 1 }} />
          <RenderOps isDuration={false} isEnemy={isWarPlan} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProvinceOps;
